//NBL1_Staff Pages
import rules from "../../Data/Rules"
import functions from "../../Data/Functions"
import settings from "../Settings/BIGV_Settings"
import Verification from "../Steps/Verification"
import Base_Details from "../Steps/BaseDetails"
import store from "../../veux/store"

let Associations, Clubs
let step2, step3


// BIGV Staff Step Schema
const Load_BIGV_Staff_Steps = () => {
    return {
        Portal: '2024 BIGV Staff',
        // MainColor: "#0305a1",
        MainColor: "#f5924c",
        Logo: require(`../../assets/BigVLogoNewT.png`),
        Title: `<h2>Big V Staff Registration Form</h2>`,
        Description: ``,
        Model: {},
        steps: [
            // Step 1
            {
                stepno: 1,
                title: 'Introduction',
                valid: true,
                nextBtn: "NO",
                backBtn: "NO",
                information: `<H2 style="text-align:center;">Welcome to Big V 2024!</H2>
                            </p>
                            With Round 1 commencing on <b>16th/17th March</b> we look forward to getting back 
                            on court and growing together as a league in 2024. With exciting new improvements to 
                            the league, we want to work more with YOU to develop the competition further and continue 
                            to make every game an event!
                            </p> 
                            <hr>
                            <br>
                            Before beginning your registration process, please take the time to read over the following:
                            <br><br>
                            <ul>
                            <li>Once a players registration to an Association for the Big V season has been approved 
                            by the league, the player and Association Delegate will receive email notification of approval</li>
                            <li>If any player is intending to play both Youth and Senior teams in 2024, please ensure 
                            you select both teams in the registration</li>
                            <li>If you are registering during the season, please submit your registration prior to 
                            <b>4pm Friday</b> for approval for those weekends round games</li>
                            <li>Players cannot register to play post the cut off period for finals qualification. 
                            See the link to find your division. 
                            <a href="https://admin.ownurgoal.net.au/_lib/file/doc/2024_Finals_Qualification_Requirements.pdf" target="_blank">2024 Big V Finals Qualification per Division</a></li>
                            <li>Any player who has registered and been assigned to a team of a NBL1 Association 
                            and/or equivalent highest level in the state in that same competition year may not register and 
                            transfer in the Big V 2024 season after the states season deadline of 11:59pm 26 May 2024 (End of Round 8).  </li>
                            </ul>
                            <br>
                            </p>
                            You must complete all mandatory fields. If you do not, then the submitted registration will not proceed.  
                            </p>
                            If you encounter any issues please contact Big V via email <a href="mailto:BigV@basketballvictoria.com.au">BigV@basketballvictoria.com.au</a> for assistance.`,
                Schema: {
                    continue: {
                        type: 'btn',
                        block: true,
                        rounded: true,
                        color: "orange",
                        label: 'Continue',
                        iconRight: 'check',
                        col: 12,
                        class: 'mx-0 px-10',
                        onClick: (val, home) => {
                            let { data, schema, obj } = val
                            home.next()
                        }
                    }
                },
            },
            // Step 2
            step2,
            // Step 3
            step3,
            // Step 4
            {
                stepno: 4,
                title: 'Rego',
                valid: true,
                information: '',
                Schema: {
                    Association: {
                        type: "select",
                        label: "Association?",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Association is Required')],
                        class: 'mx-1 px-1',
                        items: Associations,
                        returnObject: true,
                        itemText: 'Detail',
                        onInput: async (ev, portal) => {
                            if (ev.data.Teams && ev.data.Teams.length > 0) {
                                ev.data.Teams.splice(0, ev.data.Teams.length)
                            }
                            Clubs = await settings.LookupTeams(
                                ev.data.Association.Code_id,
                                ev.data.CompSelect
                            )
                            if (ev.data.CompSelect) {
                                ev.schema.Teams.hidden = false
                                ev.schema.Teams.rules = [rules.requiredSelSingle]
                                ev.schema.Teams.items = Clubs
                            } else {
                                ev.schema.Teams.hidden = true
                                ev.schema.Teams.rules = []
                            }
                        }
                    },
                    CompSelect: {
                        "type": "select",
                        "label": "Competition Selection",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Competition Selection is Required')],
                        class: 'mx-1 px-1',
                        items: settings.CompType,
                        onInput: async (ev) => {
                            if (ev.data.Teams && ev.data.Teams.length > 0) {
                                ev.data.Teams.splice(0, ev.data.Teams.length)
                            }
                            Clubs = await settings.LookupTeams(
                                ev.data.Association.Code_id,
                                ev.data.CompSelect
                            )
                            if (ev.data.Association) {
                                ev.schema.Teams.hidden = false
                                ev.schema.Teams.rules = [rules.requiredSelSingle]
                                ev.schema.Teams.items = Clubs
                            } else {
                                ev.schema.Teams.hidden = true
                                ev.schema.Teams.rules = []
                            }
                        }
                    },
                    Teams: {
                        type: "select",
                        label: "What team are you associated with?",
                        multiple: true,
                        outlined: true,
                        dense: true,
                        hidden: true,
                        clearable: true,
                        col: 12,
                        rules: [rules.requiredSelSingle],
                        class: 'mx-1 px-1',
                        items: Clubs,
                        Role: 1,
                        Accreditation: settings.PlayerAccred,
                        AccredStart: '',
                        AccredEnd: '',
                        AccredTeam: 3223,
                        returnObject: true,
                        itemText: 'Detail',
                        noDataText: 'Please Enter Association & Competition Selection First',
                        onInput: async (ev, portal) => {
                            if (ev.data.Teams.find((team) => {
                                return team.Detail.includes("Championship") && !team.Detail.includes("Youth")
                            })) {
                                ev.schema.MatchFixing.hidden = store.getters.integrity
                                ev.schema.MatchFixing.rules = (store.getters.integrity) ? [] : [rules.requiredMsg('Introduction to Match-Fixing Certificate is Required')]
                                ev.schema.haveMatchFixing.hidden = !store.getters.integrity
                            } else {
                                ev.schema.MatchFixing.hidden = true
                                ev.schema.MatchFixing.rules = []
                                ev.schema.haveMatchFixing.hidden = true
                            }
                        },
                        OUG: { Contact_Roles: true, Type: "Teams" }
                    },
                    MatchFixing: {
                        type: 'file',
                        label: 'BA Integrity Gambling & Match Fixing Certificate',
                        multiple: false,
                        accept: "image/*,application/pdf",
                        outlined: true,
                        hidden: true,
                        dense: true,
                        col: 12,
                        rules: [rules.fileSize()],
                        class: 'mx-1 px-1',
                        Startslot: `This is a MANDATORY requirement for all Championship senior staff.</br>
                                            <b>Click below to access and complete the course requirement:</b></br>
                                            <a href="https://basketballaustralia.etrainu.com/training/?event=course.purchase&bundleID=3F0F3FD7-A729-42C2-9F88-41CA9C6B5C97&secret=5E2104A0-BE72-CB0A-62F8BC01C42F51F2" target="blank">BA Integrity Course Registration - Gambling and Match Fixing Course</a> </br>
                                            </br>`,
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: "BA Integrity Gambling & Match Fixing Certificate",
                            }
                        },
                    },
                    haveMatchFixing: {
                        type: 'text',
                        dense: true,
                        disabled: true,
                        hidden: true,
                        class: 'mx-1 px-1',
                        Startslot: `<H4 style="text-align:center;color:red">We already have a copy of your BA Integrity Gambling & Match Fixing Certificate</H4>`
                    },
                    DOB: {
                        type: 'text',
                        ext: 'date',
                        locale: 'en',
                        label: `Date of Birth (${store.getters.getdateFormat})`,
                        outlined: true,
                        dense: true,
                        mask: store.getters.getdateMask,
                        rules: [rules.requiredMsg('Date of Birth is Required'),
                        rules.minAge(`You must be over 16 years`, '2008-03-17')],
                        class: 'mx-1 px-1',
                        onInput: (ev, portal) => { },
                        OUG: { Contacts: { Field: "date_of_birth" } }
                    },
                    Position: {
                        type: "select",
                        label: "Staff Position",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Staff Position is Required')],
                        class: 'mx-1 px-1',
                        items: settings.StaffRoles,
                        value: '',
                        onInput: async (ev, portal) => {
                            let index = settings.StaffRoles.findIndex((ele) => {
                                return (ele == ev.data.Position);
                            })
                            ev.schema.Teams.Role = settings.StaffRoleids[index]
                            ev.schema.Teams.Accreditation = settings.StaffAccredids[index]
                            switch (ev.obj.value) {
                                case "Coach":
                                case "Assistant Coach":
                                    ev.schema.Accreditation.hidden = false
                                    ev.schema.Accreditation.rules = [rules.requiredMsg('Accreditation is Required')]
                                    ev.schema.CoachingCourse.hidden = false
                                    ev.schema.CoachingCourse.rules = [rules.requiredMsg('Coaches Course Certificate is Required'), rules.fileSize()]
                                    break;
                                default:
                                    ev.schema.Accreditation.hidden = true
                                    ev.schema.Accreditation.rules = []
                                    ev.schema.CoachingCourse.hidden = true
                                    ev.schema.CoachingCourse.rules = []
                                    break;
                            }

                        },
                        OUG: { Contact_Details: { Type: 346, Action: "SingleDesc" } }
                    },
                    Accreditation: {
                        type: "select",
                        label: "Current Accreditation",
                        outlined: true,
                        dense: true,
                        hidden: true,
                        rules: [],
                        class: 'mx-1 px-1',
                        items: ["Community", "Club", "Association", "Performance", "Master"],
                        value: '',
                        OUG: { Contact_Details: { Type: 1934, Action: "SingleDesc" } }
                    },
                    CoachingCourse: {
                        type: 'file',
                        label: 'Coaching Course Certificate',
                        multiple: false,
                        outlined: true,
                        hidden: true,
                        dense: true,
                        accept: "image/*,application/pdf",
                        rules: [rules.requiredMsg('Coaches Course Certificate is Required'), rules.fileSize()],
                        class: 'mx-1 px-1',
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: "Coaching Course Certificate",
                            }
                        },
                    },
                },
                PreStep: (thisStep, portal) => {
                    let { Model, Schema } = thisStep
                },
            },
            //Step 5
            {
                stepno: 5,
                title: 'Confirmation',
                valid: true,
                information: ``,
                Model: {},
                Schema: {
                    Participate: {
                        addText: "",
                        type: 'checkbox',
                        label: `I have read and agree to the terms and conditions of participation 
                                        in Basketball Victoria's Senior Representative League Big V.`,
                        color: "primary",
                        value: "Agree to all Terms and Conditions for BigV",
                        rules: [rules.requiredMsg('Confirmation and acceptance of Participation Requirements is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Participation Requirements</h3>`,
                        Endslot: `<a href="https://www.basketballvictoria.com.au/about/about-us/terms" target="blank">
                                        Basketball Victoria Terms and Conditions of Participation</a>`,
                        OUG: { Answer: true }
                    },
                    staffuniformConfirm: {
                        addText: "",
                        type: 'checkbox',
                        label: `I will abide by Big V dress standard requirements and am aware fines are issued for non compliance`,
                        color: "primary",
                        value: "Agree to abide by Big V Dress Standards",
                        rules: [rules.requiredMsg('Confirmation of Staff Garment Policy is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Clothing Requirements</h3>
                                            <br>
                                            <h4>(a)	Coaches</h4>
                                                <i><ul>Coaches must wear a collared shirt. If this is a polo shirt 
                                                then it must be an Association branded polo. During colder weather 
                                                it is understandable that this will be covered by a jacket that must 
                                                be either an Association tracksuit jacket or other jacket that fits 
                                                the general description of business casual wear. <br>
                                                Denim, shorts or tracksuit pants are not permitted for Coaches and their Assistants.<br>
                                                Shoes must be clean and tidy.</ul><br></i>
                                                <h4>(b)	Team Managers</h4>
                                                <i><ul>We recognise team managers have different responsibilities and therefore the bench dress code standard can be modified slightly.<br>
                                                Team managers should be dressed appropriately and neatly in association branded clothing
                                                </ul></i>`,
                        OUG: { Answer: true }
                    },
                    // uniformConfirm: {
                    //     addText: "",
                    //     type: 'checkbox',
                    //     label: `I read and agreed to the players garment compression policy and will ensure all players are educated and aligned with requirements.`,
                    //     color: "primary",
                    //     value: "Agree to enforce the Compression Garment Policy with my players",
                    //     rules: [rules.requiredMsg('Confirmation of Compression Garment Policy is Required')],
                    //     class: 'mx-1 px-1',
                    //     col: 12,
                    //     Startslot: `<h3>Uniform Requirements</h3><br>
                    //     <a href="https://admin.ownurgoal.net.au/_lib/file/OUGImages/dec17d5d-cf97-4fe8-8697-75f6d011b1df.pdf" target="blank">
                    //                     Basketball Victoria Leagues Uniform and Undergarment Regulations</a>`,
                    //     OUG: { Answer: true }
                    // },
                    cocOperation: {
                        addText: "",
                        type: 'checkbox',
                        label: `I understand and agree to be bound by the Big V Rules of Operation.`,
                        color: "primary",
                        value: "Agree to be bound by BigV Rules of Operation",
                        rules: [rules.requiredMsg('Confirmation of Big V Rules of Operation is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Endslot: `<a href="https://admin.ownurgoal.net.au/_lib/file/OUGImages/0de67f2e-e19b-4598-821d-e44a8cc98335.pdf" target="blank">
                                        2024 Big V Rules of Operation</a>`,
                        Startslot: `<h3>BigV Rules of Operation Requirements</h3>`,
                        OUG: { Answer: true }
                    },
                    cocConfirm: {
                        addText: "",
                        type: 'checkbox',
                        label: `I confirm that I will adhere to the Basketball Victoria Code of Conduct`,
                        color: "primary",
                        value: "Confirm I will adhere to BV Code of Conduct",
                        rules: [rules.requiredMsg('Confirmation of Code of Conduct is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Endslot: `<a href="https://www.basketballvictoria.com.au/resources/association-resources/policies#codes-of-conduct" target="blank">
                                        Basketball Victoria Code of Conduct</a>`,
                        Startslot: `<h3>Code of Conduct Requirements</h3>`,
                        OUG: { Answer: true }
                    },
                    baIntegrityConfirm: {
                        addText: "",
                        type: 'checkbox',
                        label: `I agree to abide by Basketball Australia's National Integrity Framework`,
                        color: "primary",
                        value: "Agree to BA National Integrity Framework",
                        rules: [rules.requiredMsg('Confirmation of BA Integrity Requirements is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Endslot: `<a href="https://australia.basketball/integrity/" target="blank">
                                        Basketball Australia National Integrity Framework</a>`,
                        Startslot: `<h3>BA Integrity Requirements</h3>`,
                        OUG: { Answer: true }
                    },
                    useImages: {
                        addText: "",
                        type: 'checkbox',
                        label: `I acknowledge that BV, Big V and my Club may use images, video, or similar of me for the promotion of the League and the Club.`,
                        color: "primary",
                        value: "Acknowledge use of my Images and Video",
                        rules: [rules.requiredMsg('Use of Images confirmation is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Image Requirements</h3>`,
                        OUG: { Answer: true }
                    },
                    attendTribunal: {
                        addText: "",
                        type: 'checkbox',
                        label: 'I undertake to attend meetings of the Basketball Victoria Tribunal whenever required to do so and consent to the subsequent reporting of the proceedings of such meetings and hearings.',
                        color: "primary",
                        value: "Agree to attend Tribunal or other meetings",
                        rules: [rules.requiredMsg('Agreement to Attend is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Tribunal Requirements</h3>`,
                        OUG: { Answer: true }
                    },
                    infoAccurate: {
                        addText: "",
                        type: 'checkbox',
                        label: 'I confirm that I have provided infomation honestly and that it is both true and accurate.',
                        color: "primary",
                        value: "Confirm information all honest and correct",
                        rules: [rules.requiredMsg('Accurate Information confirmation is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Information Requirements</h3>`,
                        OUG: { Answer: true }
                    },
                },
            },
            // Step 6
            {
                stepno: 6,
                title: 'Finalisation',
                valid: true,
                information: `Thank you for your submitted registration for the 2024 Big V season.<br></br>
                            Please note this submitted registration is <b>PENDING APPROVAL</b> from the 
                            league and you and your Association Delegate will receive an email notification 
                            once your registration has been reviewed and approved by the league.<br></br>
                            If your registration has not been approved the league will contact your 
                            Association Delegate to inform them of any further requirements to meet 
                            league eligibility approval for the season.<br></br>

                            <b>Please note that if your registration has been submitted during the 
                            season after 4pm on the Friday prior to a weekends round your 
                            registration will NOT be reviewed and/or approved until the following 
                            round as you have missed that weekends round deadline to submit your 
                            registration.</b>
                            <hr><br></br>


                            Please stay up to date with all Big V news and information throughout the season on the <a href="https://www.basketballvictoria.com.au/bigv/home" target="blank">Big V website</a><br></br>
                            Please also note the number of games required to be played per division to qualify for finals
                            <a href="https://admin.ownurgoal.net.au/_lib/file/doc/2024_Finals_Qualification_Requirements.pdf" target="blank">2024 Big V Finals Qualification</a>`,
                Model: {},
                Schema: {}
            }
        ]
    }
}

export default {

    LoadSchema: async (Parameters) => {
        step2 = await Verification.LoadSchema(2)
        step3 = await Base_Details.LoadSchema(3)
        Associations = await functions.GetCodeBy({ State_Champs: 3223, Type: "Associations" }, true)
        return Load_BIGV_Staff_Steps()
    },

}